import type { WidgetIconName } from '@widgets/shared/icons/icons'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const channelIconMap: Record<WebWidgetChannelType, WidgetIconName | 'whatsapp' | 'facebook' | 'instagram'> = {
  [WebWidgetChannelType.EMAIL]: 'email',
  [WebWidgetChannelType.SMS]: 'message',
  [WebWidgetChannelType.CALL]: 'phone',
  [WebWidgetChannelType.CHAT]: 'tmi-message-bubble',
  [WebWidgetChannelType.WHATSAPP]: 'whatsapp',
  [WebWidgetChannelType.FACEBOOK]: 'facebook',
  [WebWidgetChannelType.INSTAGRAM]: 'instagram',
}
